import React from 'react';
// The App component's contents are currently a placeholder — please update this file first for a new design / component!
import { Banner } from './components/Banner';
import { Header } from './components/Header';
import { DoctorSection } from './components/DoctorSection';
import { IngredientSection } from './components/IngredientSection';
import { FormulaSection } from './components/FormulaSection';
import { ReviewSection } from './components/ReviewSection';
import { CTASection } from './components/CTASection';
import { StickyBanner } from './components/StickyBanner';
export function App() {
  return <div className="w-full bg-white" data-id="element-0">
      <Banner data-id="element-1" />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-2">
        <Header data-id="element-3" />
        <DoctorSection data-id="element-4" />
        <div className="my-12 px-4 md:px-0" data-id="element-5">
          <p className="text-lg mb-8 text-left leading-relaxed" data-id="element-6">
            Look, I'm going to be straight with you.
          </p>
          <p className="text-lg mb-8 text-left leading-relaxed" data-id="element-7">
            If you've been struggling to lose stubborn belly fat or build muscle
            despite doing everything "right," it's not your fault.
          </p>
          <p className="text-lg mb-8 text-left leading-relaxed" data-id="element-8">
            I blame the modern supplement industry. Most products are either
            packed with cheap stimulants that give you jitters and a crash, or
            they're so watered-down with fillers they might as well be sugar
            pills.
          </p>
          <p className="text-lg mb-8 text-left leading-relaxed" data-id="element-9">
            After treating over 10,000 men in my Boston clinic, I've identified
            5 specific, natural ingredients that actually work to help men burn
            fat, pack on muscle, and feel more masculine.
          </p>
          <p className="text-lg mb-8 text-left leading-relaxed" data-id="element-10">
            These are not your typical, run-of-the-mill compounds. You won't
            find the high-quality, clinically effective forms of these
            ingredients on Amazon, at GNC, or in any local supplement shop.
          </p>
          <h2 className="text-3xl font-bold mb-10 text-center md:text-left" data-id="element-11">
            Here's what actually works:
          </h2>
        </div>
        <IngredientSection number="1" title="KSM-66® Ashwagandha Extract" subtitle="The Ancient Warrior's Secret" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/5rW4VXzh2TNW2PLoixxrX8/KSM-66%C2%AE_Ashwagandha_Extract.png" studyUrl="https://pmc.ncbi.nlm.nih.gov/articles/PMC3573577/" description={`Ashwagandha has been used for centuries in traditional medicine, and modern research proves why it's so effective for men's performance and vitality.
The name literally translates to "smell of the horse" -- referring to its ability to give ancient warriors the strength and vitality of a stallion.
Modern research proves they were onto something powerful:
• Reduces cortisol (the stress hormone that causes belly fat) by up to 27%.
• Increases testosterone levels naturally.
• Improves muscle mass and strength.
• Enhances recovery from workouts.
But here's the thing -- not all ashwagandha is created equal. The cheap stuff you find online won't do anything. You need KSM-66®, the gold-standard extract that's been clinically tested in over 24 human studies.
You can't just pick this up at your local store.`} data-id="element-12" />
        <CTASection text="GET UP TO 50% OFF" data-id="element-13" />
        <IngredientSection number="2" title="GlucoVantage® Dihydroberberine" subtitle="5X More Powerful Than Regular Berberine" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/6C1e57GhszyigExe2Efr6u/GlucoVantage%C2%AE_Dihydroberberine.png" studyUrl="https://pmc.ncbi.nlm.nih.gov/articles/PMC8236166/" description={`Elite athletes and biohackers have known for years that berberine is incredibly effective for improving body composition. The problem? Most of it gets destroyed by your stomach acid before it can do any good.
That's why we use GlucoVantage® Dihydroberberine instead. It's a patented form that is 5 times more bioavailable than standard berberine, meaning your body actually absorbs and uses it.
What it does:
• Dramatically improves insulin sensitivity.
• Helps turn calories into muscle, not fat.
• Encourages your body to burn existing fat for fuel.
• Supports healthy blood sugar levels.
GlucoVantage® is a patented, pharmaceutical-grade ingredient that most supplement companies can't afford to use at an effective dose.`} data-id="element-14" />
        <IngredientSection number="3" title="DIM + Boron Complex" subtitle="The Natural Estrogen Blocker" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/ocxQk7UgSkq4DoEY9sCdq6/DIM_2B_Boron_Complex.png" studyUrl="https://pubmed.ncbi.nlm.nih.gov/21129941/" description={`Here's something most men don't know: your body is under constant assault from estrogen-like compounds in plastics, pesticides, and processed foods.
These "xenoestrogens" attach to your estrogen receptors and cause feminizing effects -- like man boobs, stubborn hip fat, and decreased muscle mass.
Harvard researchers have identified DIM (Diindolylmethane) as a powerful compound that helps eliminate excess estrogen. When combined with a specific form of Boron, this powerful duo:
• Helps your body detoxify from excess estrogen.
• Supports healthy free testosterone levels.
• Specifically targets chest and hip fat.
• Improves muscle hardness and definition.
The problem? You'd need to eat nearly 2 pounds of broccoli every day to get an effective dose of DIM. And the boron needs to be in a specific chelated form to be properly absorbed.
Good luck finding that combination on Amazon.`} data-id="element-15" />
        <IngredientSection number="4" title="Lactobacillus Gasseri (10 Billion CFU)" subtitle="The Japanese Gut Health Secret" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/bPiqvaWYtWWCKkyJox1dew/Lactobacillus_Gasseri_%2810_Billion_CFU%29.png" studyUrl="https://www.nature.com/articles/ejcn201019" description={`Modern science has confirmed what researchers in Japan discovered years ago: one particular probiotic strain—Lactobacillus Gasseri—is uniquely effective for improving men's body composition.
In a landmark 12-week clinical study, participants who supplemented with L. Gasseri saw:
• An 8.5% reduction in visceral (belly) fat.
• A significant decrease in waist circumference.
• Improved insulin sensitivity.
• Better nutrient absorption from food.
But here's the catch: Most probiotic supplements don't contain L. Gasseri at all. And if they do, it's usually in such small amounts that it won't make a difference.
To be effective, you need at least 10 billion CFU of live, viable bacteria, properly encapsulated to survive stomach acid.`} data-id="element-16" />
        <IngredientSection number="5" title="Grains of Paradise (12.5% 6-paradol)" subtitle="The West African Fat-Burning Secret" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/iKu9TDsg5RxBsQ2aR88BcJ/Grains_of_Paradise_%2812.5_6-paradol%29.png" studyUrl="https://pubmed.ncbi.nlm.nih.gov/23308394/" description={`This isn't a trendy gimmick. Grains of Paradise is a West African spice with centuries of traditional use, now backed by hard science. Its power comes from a specific compound, 6-Paradol, which is shown to:
• Activate Brown Adipose Tissue (BAT)—your body's metabolically active "brown fat" that actually burns calories to create heat.
• Help convert stubborn white fat (storage fat) into active brown fat.
• Significantly reduce inflammatory markers.
But here's the problem: The market is flooded with cheap, generic "Grains of Paradise" extracts with no standardization. To get the powerful fat-burning benefits, research shows you need an extract standardized to 12.5% 6-Paradol.
Anything less is a waste of money.`} data-id="element-17" />
        <div className="my-12 px-4 md:px-0" data-id="element-18">
          <h2 className="text-3xl font-bold mb-10 text-center md:text-left" data-id="element-19">
            Why You Can't Just Buy These on Amazon
          </h2>
          <p className="text-lg mb-8 text-left leading-relaxed" data-id="element-20">
            Now, you might be thinking, "Great, I'll just go buy these five
            ingredients separately."
          </p>
          <p className="text-lg mb-8 text-left leading-relaxed" data-id="element-21">
            I tried that. It doesn't work.
          </p>
          <p className="text-lg mb-8 text-left leading-relaxed" data-id="element-22">
            Here's what my clinical research revealed: when you combine these
            specific ingredients in their most potent forms and in the right
            ratios, something incredible happens. They work synergistically.
          </p>
          <p className="text-lg mb-8 text-left leading-relaxed" data-id="element-23">
            The KSM-66® lowers cortisol, which allows the GlucoVantage® to
            work more effectively on insulin sensitivity. The DIM clears out
            excess estrogen, creating a better hormonal environment for the
            Grains of Paradise to activate fat burning. And the L. Gasseri
            improves gut health, which enhances the absorption of all the other
            ingredients.
          </p>
          <p className="text-lg mb-8 text-left leading-relaxed" data-id="element-24">
            After years of clinical experimentation, I found these to be exact
            ratios that produced maximum results in my patients. But I hit a
            wall. You simply couldn't buy these ingredients in their proper
            forms and potencies in one place.
          </p>
          <p className="text-lg mb-8 text-left leading-relaxed" data-id="element-25">
            I called every top-tier formulator in the country. Nobody could
            source KSM-66®, GlucoVantage®, and a clinical-grade DIM complex
            together. And certainly not with the precise ratios I knew worked.
          </p>
        </div>
        <FormulaSection data-id="element-26" />
        <div className="my-12" data-id="element-27">
          <h2 className="text-3xl font-bold mb-8" data-id="element-28">
            The results speak for themselves:
          </h2>
          <div className="space-y-6" data-id="element-29">
            <div className="p-6 bg-gray-50 rounded-lg" data-id="element-30">
              <div className="flex flex-col md:flex-row gap-6 mb-4" data-id="element-31">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/h6byw2EQxsHB1Y6TqAvtLQ/ChatGPT_Image_1_sept_2025%2C_11_22_37_a.m..png" alt="James T. before and after using Drift" className="w-full md:w-1/3 h-auto rounded-lg" data-id="element-32" />
                <p className="text-lg italic md:w-2/3" data-id="element-33">
                  "After wasting money on 'fat burners,' I didn't believe the
                  claims. But the science made sense. Week 2: more energy. Week
                  4: pants looser. Week 8: haven't felt this good since my 20s."
                </p>
              </div>
              <p className="font-bold mt-4" data-id="element-34">James T., 47</p>
            </div>
            <div className="p-6 bg-gray-50 rounded-lg" data-id="element-35">
              <div className="flex flex-col md:flex-row gap-6 mb-4" data-id="element-36">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4U5s8vPE5v8rbP4DQLfpyo/Robert_J.%2C_45.png" alt="Robert J. before and after using Drift" className="w-full md:w-1/3 h-auto rounded-lg" data-id="element-37" />
                <p className="text-lg italic md:w-2/3" data-id="element-38">
                  "Just seeing my reflection in a window fills me with
                  confidence, maybe even a bit of joy. I should have done this a
                  long time ago. And yes, people treat you differently, I tend
                  to get a lot more small talk, smiles and attention from women
                  (I'm not married). To be sure, part of this is my own
                  confidence improving"
                </p>
              </div>
              <p className="font-bold mt-4" data-id="element-39">Robert J., 45</p>
            </div>
            <div className="p-6 bg-gray-50 rounded-lg" data-id="element-40">
              <div className="flex flex-col md:flex-row gap-6 mb-4" data-id="element-41">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/27TryvMd6VG8ggXV8VxBd8/ChatGPT_Image_1_sept_2025%2C_11_13_42_a.m..png" alt="Michael R. before and after using Drift" className="w-full md:w-1/3 h-auto rounded-lg" data-id="element-42" />
                <p className="text-lg italic md:w-2/3" data-id="element-43">
                  "I tried everything -- keto, intermittent fasting, even looked
                  into TRT. Nothing worked. After 3 weeks on Drift™, I'm down a
                  belt notch, sleeping better, and my wife actually commented on
                  my energy. This is the real deal."
                </p>
              </div>
              <p className="font-bold mt-4" data-id="element-44">Michael R., 41</p>
            </div>
          </div>
        </div>
        <div className="my-12 px-4 md:px-0" data-id="element-45">
          <h2 className="text-3xl font-bold mb-10 text-center md:text-left" data-id="element-46">
            Here's What I'm Offering You Today - 50% OFF
          </h2>
          <p className="text-lg mb-8 text-left leading-relaxed" data-id="element-47">
            Look, a single bottle of just the KSM-66® or GlucoVantage® at
            these doses would cost you over $50. You're getting all five
            pharmaceutical-grade ingredients in one.
          </p>
          <p className="text-lg mb-8 text-left leading-relaxed" data-id="element-48">
            But I know you've likely wasted money on supplements that don't
            work, and you might be skeptical. I respect that.
          </p>
          <p className="text-lg mb-8 text-left leading-relaxed" data-id="element-49">
            That's why I've arranged a special offer for readers of this
            article.
          </p>
          <p className="text-lg mb-8 text-left leading-relaxed" data-id="element-50">
            For a limited time, you can try Drift™ for up to 50% off.
          </p>
          <p className="text-lg mb-8 text-left leading-relaxed" data-id="element-51">
            Plus, it comes with my personal 90-day, money-back guarantee. If you
            don't notice more energy, better sleep, and your clothes fitting
            looser within 90 days, simply contact our support team, and you'll
            get a full refund. No questions asked.
          </p>
          <p className="text-lg mb-8 text-left leading-relaxed" data-id="element-52">
            But there is one catch: We only produce Drift™ in small,
            highly-controlled batches to ensure quality. As of August 20, 2025,
            we have fewer than 500 bottles left in our current inventory.
          </p>
          <p className="text-lg mb-8 text-left leading-relaxed" data-id="element-53">
            Once they're gone, it could be 6-8 weeks before our next batch is
            ready, and I can't guarantee this 50% off pricing will still be
            available.
          </p>
        </div>
        <CTASection text="Click Here & Claim Up To 50% OFF" data-id="element-54" />
        <div className="my-12 px-4 md:px-0" data-id="element-55">
          <p className="text-lg mb-8 text-left leading-relaxed" data-id="element-56">
            Don't spend another year struggling with stubborn fat and low
            energy. These five ingredients have been helping men build lean,
            powerful physiques for thousands of years.
          </p>
          <p className="text-lg mb-8 text-left leading-relaxed" data-id="element-57">
            Now you can get all of them in one convenient formula, at the exact
            doses proven to work in clinical studies.
          </p>
        </div>
        <CTASection text="Order Drift™ Risk-Free Today -- Save 50%" data-id="element-58" />
        <ReviewSection data-id="element-59" />
        <CTASection text="Order Drift™ Risk-Free Today -- Save 50%" data-id="element-60" />
        <div className="text-sm text-gray-500 mt-12 text-center px-4 md:px-0" data-id="element-61">
          <p data-id="element-62">
            *These statements have not been evaluated by the Food and Drug
            Administration. This product is not intended to diagnose, treat,
            cure, or prevent any disease. Results may vary.
          </p>
        </div>
      </div>
      <StickyBanner data-id="element-63" />
    </div>;
}